export const BUILD_STATES = {
  SKIPPED: "SKIPPED",
  SCHEDULED: "SCHEDULED",
  STARTED: "STARTED",
  RUNNING: "RUNNING",
  PASSED: "PASSED",
  SOFT_FAILED: "SOFT_FAILED",
  FAILING: "FAILING",
  FAILED: "FAILED",
  CANCELING: "CANCELING",
  CANCELED: "CANCELED",
  CREATING: "CREATING",
  BLOCKED: "BLOCKED",
  NOT_RUN: "NOT_RUN",
} as const;

export default BUILD_STATES;

// BuildStates provided by the backend are lower cased so we'll provide a type with the lowercased
// version of the uppercased keys in BUILD_STATES above
export type BuildStates =
  | "started"
  | "skipped"
  | "scheduled"
  | "running"
  | "passed"
  | "soft_failed"
  | "failing"
  | "failed"
  | "canceling"
  | "canceled"
  | "creating"
  | "blocked"
  | "not_run";

const TERMINAL_STATES = new Set<BuildStates>([
  "canceled",
  "failed",
  "not_run",
  "passed",
  "skipped",
]);

export function isTerminalBuildState(state: BuildStates): boolean {
  return TERMINAL_STATES.has(state);
}

export const FINISHED_STATES = new Set<BuildStates>(["canceled", "failed", "passed"]);
